function DictionaryElementVO(id, value, description, englishValue, englishDescription, deleted, author, grouping, parent, children) {
    this.id = id;
    this.value = value;
    this.description = description;
    this.englishValue = englishValue;
    this.englishDescription = englishDescription;
    this.grouping = grouping;
    this.deleted = deleted;
    this.author = author;
    this.parent = parent;
    this.children = children;


    var _typeContext = {
        author: UserVO,
        parent: DictionaryElementVO,
        children: DictionaryElementVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {};

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
